import { render, staticRenderFns } from "./TelMarketStatistics.vue?vue&type=template&id=5d6428a2&scoped=true&"
import script from "./TelMarketStatistics.vue?vue&type=script&lang=js&"
export * from "./TelMarketStatistics.vue?vue&type=script&lang=js&"
import style0 from "./TelMarketStatistics.vue?vue&type=style&index=0&id=5d6428a2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6428a2",
  null
  
)

export default component.exports